const TAG = "CDataUtil";

export class CDataUtil {
  public static extractBranchGrpList(serviceGrp: any) {
    var _branchGrpIdList: number[] = [];

    try {
      const branchGrpList = serviceGrp.BranchGrpList.BranchGrp;
      if (branchGrpList.length > 0) {
        for (let branchGrp of branchGrpList) {
          if (branchGrp.IndBranchGrp) {
            _branchGrpIdList.push(branchGrp.IndBranchGrp.BranchGrpId);
          }
        }
      } else {
        if (branchGrpList.IndBranchGrp) {
          _branchGrpIdList.push(branchGrpList.IndBranchGrp.BranchGrpId);
        }
      }
    } catch (err: any) {
      throw err;
    }

    return _branchGrpIdList;
  }

  public static extractDisplayStringValueByLanguageId(
    languageStringList: any,
    languageId: string
  ) {
    var displayStringValue = "";

    try {
      if (languageStringList) {
        if (languageStringList.length > 0) {
          for (let languageString of languageStringList) {
            const _languageId = languageString.LanguageId;
            const _displayStringValue =
              languageString.DisplayString.DisplayStringValue;
            if (languageId === _languageId) {
              displayStringValue = _displayStringValue;
              break;
            }
          }
        } else {
          var languageStringObj;
          if (languageStringList.LanguageString) {
            languageStringObj = languageStringList.LanguageString;
          } else {
            languageStringObj = languageStringList;
          }

          const _languageId = languageStringObj.LanguageId;
          const _displayStringValue =
          languageStringObj.DisplayString.DisplayStringValue;
          if (languageId === _languageId) {
            displayStringValue = _displayStringValue;
          }
        }
      }
    } catch (err: any) {
      throw err;
    }

    return displayStringValue;
  }
}
